<template>
  <div v-if="api_data.Farmer" class="card rounded-0 card-custom gutter-b">
    <div class="card-header border-0 pt-5">
      <div class="card-title">
        <div class="card-label">
          <div class="font-weight-bolder">
            {{ $t('Livelihood') }}
          </div>
          <span class="text-muted mt-3 font-weight-bold font-size-sm">{{ $t('Information') }}</span>
        </div>
      </div>
    </div>
    <div class="card-body pt-2">
      <div class="card-body">
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood'"
            v-bind:head_title="'Details'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_education'"
            v-bind:head_title="'Education'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <div class="row">
          <div class="col-md-6">
            <text-input
                v-bind:form_label="'NREGA Number'"
                v-bind:form_class="'form-control-solid input-lg'"
                v-bind:file_input_name="'livelihood_nrega_number'"
                :api_data="api_data"
                v-bind:operation_mode="'read'"
            ></text-input>
          </div>
          <div class="col-md-6">
            <text-input
                v-bind:form_label="'Job-Card Number'"
                v-bind:form_class="'form-control-solid input-lg'"
                v-bind:file_input_name="'livelihood_job_card_number'"
                :api_data="api_data"
                v-bind:operation_mode="'read'"
            ></text-input>
          </div>
        </div>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_duration'"
            v-bind:head_title="'Migration Duration'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_income'"
            v-bind:head_title="'Income'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_location'"
            v-bind:head_title="'Migration Location'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_with_family'"
            v-bind:head_title="'Migration with Family'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
        <question-with-note-and-multi-input
            :api_data="api_data"
            v-bind:file_input_name="'livelihood_migration_with_family_location'"
            v-bind:head_title="'Migration with Family Location'"
            v-bind:operation_mode="'read'"
        ></question-with-note-and-multi-input>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'show-livelihood-information',
  props: {
    api_data: {
      type: Object,
      default: function () {
        return {}
      },
    },
  }
}
</script>
